export const setTempTokenForFetch = (username, password) => {
    let headers = new Headers();

    headers.set(
        'Authorization',
        'Basic ' + btoa(username + ":" + password)
    );

    return headers;
}
export default setTempTokenForFetch;